<template>
  <eagle-list
    @updatePopupSelectData="updatePopupSelectData"
    :list-key="listKey"
  ></eagle-list>
</template>

<script>
import listMixin from '@/components/list/mixins/listMixin'
import listConfig from './siteAdminListConfig'
export default {
  mixins: [listMixin],
  data: () => ({
    listKey: 'site-admin-selector',
    meta: {},
  }),
  methods: {
    updatePopupSelectData(data) {
      this.$emit('updateData', data)
    },
    async beforeIndex() {
      await Promise.all([
        this.loadSiteAdminRoles(),
      ])
    },
    async loadSiteAdminRoles() {
      const result = await this.$api.collection.siteAdminApi.roles()
      this.meta.roles = result.roles
    },
    async indexApi(params) {
      return await this.$api.collection.siteAdminApi.index(params)
    },
    getListConfig() {
      return listConfig
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
